import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { ConfigSlideId, RevalidateTarget } from '@/eventConfig/types';
import { FormPayload } from '@/form/types';
import { ValidateFieldFn } from '@/form/fields/_pipeline/useValidateField';
import { useForm } from '@/form/useForm';

export type RevalidateFieldFn = (slideId: ConfigSlideId, fieldName: string) => boolean;
export type RevalidateFieldsFn = (fieldsToRevalidate: RevalidateTarget[]) => boolean;

export interface RevalidateField {
  revalidateField: RevalidateFieldFn;
  revalidateFields: RevalidateFieldsFn;
}

export const useRevalidateField = (validateField: ValidateFieldFn): RevalidateField => {
  const { eventConfig } = useEventConfig();
  const { getFieldStatus, onChange } = useForm();

  const revalidateField: RevalidateFieldFn = (slideId, fieldName) => {
    if (getFieldStatus(fieldName) == undefined) {
      return true;
    }

    const field = eventConfig?.slides[slideId].fields.find(({ name }) => name === (fieldName as keyof FormPayload));
    const { hint, isValid } = validateField(field?.validator, getFieldStatus(fieldName)?.value);

    onChange(fieldName, {
      value: getFieldStatus(fieldName)!.value,
      isValid: isValid,
      hint: hint,
      slideId: slideId,
    });

    return isValid;
  };

  const revalidateFields: RevalidateFieldsFn = (fieldsToRevalidate) => {
    let isValid = true;

    fieldsToRevalidate.forEach((field) => {
      isValid &&= revalidateField(field.slideId, field.field);
    });

    return isValid;
  };

  return { revalidateField, revalidateFields };
};
